module.exports = __webpack_public_path__ + "static/media/treasureHuntChest.6755ee16.svg";